import { Button, Divider } from 'antd'
import { useSpreadSheetData } from '../../SpreadSheetDataProvider'
import { setFilters } from '../../SpreadSheetDataProvider/actions'
import { sparqlFilterTypes } from 'Services/WeaverUtils'
import StringFilter from './StringFilter'

RelationFilter = ({ column }) ->

  [{ filters }, dispatch] = useSpreadSheetData()

  onSearch = (type, val) ->
    dispatch(
      setFilters({
        filters...
        [column.key]: {
          type: sparqlFilterTypes.RELATION,
          val
        }
      })
    )

  <div
    onClick={(e) -> e.stopPropagation()}
    onMouseUp={(e) -> e.stopPropagation()}
    onMouseDown={(e) -> e.stopPropagation()}
  >
    <StringFilter onOk={onSearch} />
    <Divider style={{ margin: '12px 0' }} />
    <Button
      size="small"
      type="link"
      disabled={!filters[column.key]}
      onClick={ ->
        newFilters = { filters... }
        delete newFilters[column.key]
        dispatch(
          setFilters(newFilters)
        )
      }
    >Clear</Button>
  </div>

export default RelationFilter